export const SUPPORTED_IMAGES = 'png,jpg,jpeg,image';
